var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashbordIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18919 4H4.86486C4.38721 4 4 4.38721 4 4.86486V10.9189C4 11.3966 4.38721 11.7838 4.86486 11.7838H9.18919C9.66684 11.7838 10.0541 11.3966 10.0541 10.9189V4.86486C10.0541 4.38721 9.66684 4 9.18919 4Z",
    stroke: "#FF9355",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1345 4H14.8102C14.3325 4 13.9453 4.38721 13.9453 4.86486V7.45946C13.9453 7.93711 14.3325 8.32432 14.8102 8.32432H19.1345C19.6122 8.32432 19.9994 7.93711 19.9994 7.45946V4.86486C19.9994 4.38721 19.6122 4 19.1345 4Z",
    stroke: "#FF9355",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1345 12.2158H14.8102C14.3325 12.2158 13.9453 12.603 13.9453 13.0807V19.1347C13.9453 19.6124 14.3325 19.9996 14.8102 19.9996H19.1345C19.6122 19.9996 19.9994 19.6124 19.9994 19.1347V13.0807C19.9994 12.603 19.6122 12.2158 19.1345 12.2158Z",
    stroke: "#FF9355",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18919 15.6758H4.86486C4.38721 15.6758 4 16.063 4 16.5406V19.1352C4 19.6129 4.38721 20.0001 4.86486 20.0001H9.18919C9.66684 20.0001 10.0541 19.6129 10.0541 19.1352V16.5406C10.0541 16.063 9.66684 15.6758 9.18919 15.6758Z",
    stroke: "#FF9355",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordIcons);
export default __webpack_public_path__ + "static/media/dashbord-icons.1c6fa2f6ba29c1d11a86e1aa8ef44bb4.svg";
export { ForwardRef as ReactComponent };